export default {
  api: {
    url:'https://stagapi.dingapp.net/ding/api/v1/',
    mode: 'cors'
  },
  config: {
  }

}
